import { useTheme } from "@shared/theme/useTheme";

interface IconProps {
  width?: number;
  height?: number;
  fill?: string;
}

export const SidekickChatAvatarIcon = ({
  width = 40,
  height = 40,
}: IconProps) => {
  const theme = useTheme();
  const colors =
    theme.name === "light"
      ? {
          background: "#000",
          shadow1: "#1F1F1F",
          shadow2: "#3E3E3E",
          bolt: "#fff",
        }
      : {
          background: "#fff",
          shadow1: "#DFDFDF",
          shadow2: "#AEAEAE",
          bolt: "#000",
        };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 36 36"
    >
      <g clipPath="url(#clip0_1234_1124)">
        <path
          fill={colors.background}
          d="M18 35.92c9.897 0 17.92-8.023 17.92-17.92C35.92 8.103 27.897.08 18 .08 8.103.08.08 8.103.08 18c0 9.897 8.023 17.92 17.92 17.92z"
        ></path>
        <path
          fill={colors.shadow1}
          d="M18 32.21c7.848 0 14.21-6.362 14.21-14.21 0-7.848-6.362-14.21-14.21-14.21-7.848 0-14.21 6.362-14.21 14.21 0 7.848 6.362 14.21 14.21 14.21z"
        ></path>
        <path
          fill={colors.shadow2}
          d="M18 28.01c5.529 0 10.01-4.481 10.01-10.01 0-5.528-4.481-10.01-10.01-10.01-5.528 0-10.01 4.482-10.01 10.01 0 5.529 4.482 10.01 10.01 10.01z"
        ></path>
        <path
          fill={colors.bolt}
          d="M24.555 9.974c-.095-.351.34-.598.594-.336a2.396 2.396 0 002.346.648c.352-.095.599.34.337.593a2.396 2.396 0 00-.648 2.347c.095.351-.34.598-.594.336a2.396 2.396 0 00-2.346-.648c-.352.095-.599-.34-.337-.593a2.396 2.396 0 00.648-2.347z"
        ></path>
        <path
          fill={colors.bolt}
          d="M26.594 17.047a.78.78 0 00-.487-.555l-6.45-1.266 2.26-7.978a.79.79 0 00-.399-.847.77.77 0 00-.925.156L9.68 18.245a.769.769 0 00-.019 1.049.799.799 0 00.312.218l6.529 1.187-2.34 8.056a.79.79 0 00.4.848.817.817 0 00.36.087.769.769 0 00.565-.243L26.4 17.758a.77.77 0 00.195-.71z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1234_1124">
          <path fill={colors.bolt} d="M0 0H36V36H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
